import AK0_2_12_0 from "Assets/svg/akardeoni/AK0_2_12_0.svg";
import ak_2_0 from "Assets/svg/akardeoni/ak_2_0.svg";
import ak_3_0 from "Assets/svg/akardeoni/ak_3_0.svg";
import ak_4_0 from "Assets/svg/akardeoni/ak_4_0.svg";
import ak_5_0 from "Assets/svg/akardeoni/ak_5_0.svg";
import ak_6_0 from "Assets/svg/akardeoni/ak_6_0.svg";
import ak_7_0 from "Assets/svg/akardeoni/ak_7_0.svg";
import AK0_2_43_0 from "Assets/svg/akardeoni/AK0_2_43_0.svg";
import AK0_4_1212_0 from "Assets/svg/akardeoni/AK0_4_1212_0.svg";
import AK0_4_1243_0 from "Assets/svg/akardeoni/AK0_4_1243_0.svg";
import AK0_4_4343_0 from "Assets/svg/akardeoni/AK0_4_4343_0.svg";
import AK0_6_121212_0 from "Assets/svg/akardeoni/AK0_6_121212_0.svg";
import AK0_6_121243_0 from "Assets/svg/akardeoni/AK0_6_121243_0.svg";
import AK0_6_124343_0 from "Assets/svg/akardeoni/AK0_6_124343_0.svg";
import AK0_6_434343_0 from "Assets/svg/akardeoni/AK0_6_434343_0.svg";
import AK1_3_125_0 from "Assets/svg/akardeoni/AK1_3_125_0.svg";
import AK1_3_126_0 from "Assets/svg/akardeoni/AK1_3_126_0.svg";
import AK1_3_543_0 from "Assets/svg/akardeoni/AK1_3_543_0.svg";
import AK1_3_643_0 from "Assets/svg/akardeoni/AK1_3_643_0.svg";
import AK1_4_1226_0 from "Assets/svg/akardeoni/AK1_4_1226_0.svg";
import AK1_4_5443_0 from "Assets/svg/akardeoni/AK1_4_5443_0.svg";
import AK1_5_12125_0 from "Assets/svg/akardeoni/AK1_5_12125_0.svg";
import AK1_5_12126_0 from "Assets/svg/akardeoni/AK1_5_12126_0.svg";
import AK1_5_12543_0 from "Assets/svg/akardeoni/AK1_5_12543_0.svg";
import AK1_5_12643_0 from "Assets/svg/akardeoni/AK1_5_12643_0.svg";
import AK1_5_54343_0 from "Assets/svg/akardeoni/AK1_5_54343_0.svg";
import AK1_5_64343_0 from "Assets/svg/akardeoni/AK1_5_64343_0.svg";
import AK1_6_121226_0 from "Assets/svg/akardeoni/AK1_6_121226_0.svg";
import AK1_6_125443_0 from "Assets/svg/akardeoni/AK1_6_125443_0.svg";
import AK1_6_544343_0 from "Assets/svg/akardeoni/AK1_6_544343_0.svg";
import AK1_7_1212125_0 from "Assets/svg/akardeoni/AK1_7_1212125_0.svg";
import AK1_7_1212126_0 from "Assets/svg/akardeoni/AK1_7_1212126_0.svg";
import AK1_7_1212543_0 from "Assets/svg/akardeoni/AK1_7_1212543_0.svg";
import AK1_7_1212643_0 from "Assets/svg/akardeoni/AK1_7_1212643_0.svg";
import AK1_7_1254343_0 from "Assets/svg/akardeoni/AK1_7_1254343_0.svg";
import AK1_7_1264343_0 from "Assets/svg/akardeoni/AK1_7_1264343_0.svg";
import AK1_7_5434343_0 from "Assets/svg/akardeoni/AK1_7_5434343_0.svg";
import AK1_7_6434343_0 from "Assets/svg/akardeoni/AK1_7_6434343_0.svg";
import AK2_3_127_0 from "Assets/svg/akardeoni/AK2_3_127_0.svg";
import AK2_3_128_0 from "Assets/svg/akardeoni/AK2_3_128_0.svg";
import AK2_3_743_0 from "Assets/svg/akardeoni/AK2_3_743_0.svg";
import AK2_3_843_0 from "Assets/svg/akardeoni/AK2_3_843_0.svg";
import AK2_4_1228_0 from "Assets/svg/akardeoni/AK2_4_1228_0.svg";
import AK2_4_7443_0 from "Assets/svg/akardeoni/AK2_4_7443_0.svg";
import AK2_5_12127_0 from "Assets/svg/akardeoni/AK2_5_12127_0.svg";
import AK2_5_12128_0 from "Assets/svg/akardeoni/AK2_5_12128_0.svg";
import AK2_5_12743_0 from "Assets/svg/akardeoni/AK2_5_12743_0.svg";
import AK2_5_12843_0 from "Assets/svg/akardeoni/AK2_5_12843_0.svg";
import AK2_5_74343_0 from "Assets/svg/akardeoni/AK2_5_74343_0.svg";
import AK2_5_84343_0 from "Assets/svg/akardeoni/AK2_5_84343_0.svg";
import AK2_6_121228_0 from "Assets/svg/akardeoni/AK2_6_121228_0.svg";
import AK2_6_127443_0 from "Assets/svg/akardeoni/AK2_6_127443_0.svg";
import AK2_6_744343_0 from "Assets/svg/akardeoni/AK2_6_744343_0.svg";
import AK2_7_1212127_0 from "Assets/svg/akardeoni/AK2_7_1212127_0.svg";
import AK2_7_1212128_0 from "Assets/svg/akardeoni/AK2_7_1212128_0.svg";
import AK2_7_1212743_0 from "Assets/svg/akardeoni/AK2_7_1212743_0.svg";
import AK2_7_1212843_0 from "Assets/svg/akardeoni/AK2_7_1212843_0.svg";
import AK2_7_1274343_0 from "Assets/svg/akardeoni/AK2_7_1274343_0.svg";
import AK2_7_1284343_0 from "Assets/svg/akardeoni/AK2_7_1284343_0.svg";
import AK2_7_7434343_0 from "Assets/svg/akardeoni/AK2_7_7434343_0.svg";
import AK2_7_8434343_0 from "Assets/svg/akardeoni/AK2_7_8434343_0.svg";

export const foldSlideImageName = [
  { key: "AK0_2_12_0", icon: AK0_2_12_0 },
  { key: "ak_2_0", icon: ak_2_0 },
  { key: "ak_3_0", icon: ak_3_0 },
  { key: "ak_4_0", icon: ak_4_0 },
  { key: "ak_5_0", icon: ak_5_0 },
  { key: "ak_6_0", icon: ak_6_0 },
  { key: "ak_7_0", icon: ak_7_0 },
  { key: "AK0_2_43_0", icon: AK0_2_43_0 },
  { key: "AK0_4_1212_0", icon: AK0_4_1212_0 },
  { key: "AK0_4_1243_0", icon: AK0_4_1243_0 },
  { key: "AK0_4_4343_0", icon: AK0_4_4343_0 },
  { key: "AK0_6_121212_0", icon: AK0_6_121212_0 },
  { key: "AK0_6_121243_0", icon: AK0_6_121243_0 },
  { key: "AK0_6_124343_0", icon: AK0_6_124343_0 },
  { key: "AK0_6_434343_0", icon: AK0_6_434343_0 },
  { key: "AK1_3_125_0", icon: AK1_3_125_0 },
  { key: "AK1_3_126_0", icon: AK1_3_126_0 },
  { key: "AK1_3_543_0", icon: AK1_3_543_0 },
  { key: "AK1_3_643_0", icon: AK1_3_643_0 },
  { key: "AK1_4_1226_0", icon: AK1_4_1226_0 },
  { key: "AK1_4_5443_0", icon: AK1_4_5443_0 },
  { key: "AK1_5_12125_0", icon: AK1_5_12125_0 },
  { key: "AK1_5_12126_0", icon: AK1_5_12126_0 },
  { key: "AK1_5_12543_0", icon: AK1_5_12543_0 },
  { key: "AK1_5_12643_0", icon: AK1_5_12643_0 },
  { key: "AK1_5_54343_0", icon: AK1_5_54343_0 },
  { key: "AK1_5_64343_0", icon: AK1_5_64343_0 },
  { key: "AK1_6_121226_0", icon: AK1_6_121226_0 },
  { key: "AK1_6_125443_0", icon: AK1_6_125443_0 },
  { key: "AK1_6_544343_0", icon: AK1_6_544343_0 },
  { key: "AK1_7_1212125_0", icon: AK1_7_1212125_0 },
  { key: "AK1_7_1212126_0", icon: AK1_7_1212126_0 },
  { key: "AK1_7_1212543_0", icon: AK1_7_1212543_0 },
  { key: "AK1_7_1212643_0", icon: AK1_7_1212643_0 },
  { key: "AK1_7_1254343_0", icon: AK1_7_1254343_0 },
  { key: "AK1_7_1264343_0", icon: AK1_7_1264343_0 },
  { key: "AK1_7_5434343_0", icon: AK1_7_5434343_0 },
  { key: "AK1_7_6434343_0", icon: AK1_7_6434343_0 },
  { key: "AK2_3_127_0", icon: AK2_3_127_0 },
  { key: "AK2_3_128_0", icon: AK2_3_128_0 },
  { key: "AK2_3_743_0", icon: AK2_3_743_0 },
  { key: "AK2_3_843_0", icon: AK2_3_843_0 },
  { key: "AK2_4_1228_0", icon: AK2_4_1228_0 },
  { key: "AK2_4_7443_0", icon: AK2_4_7443_0 },
  { key: "AK2_5_12127_0", icon: AK2_5_12127_0 },
  { key: "AK2_5_12128_0", icon: AK2_5_12128_0 },
  { key: "AK2_5_12743_0", icon: AK2_5_12743_0 },
  { key: "AK2_5_12843_0", icon: AK2_5_12843_0 },
  { key: "AK2_5_74343_0", icon: AK2_5_74343_0 },
  { key: "AK2_5_84343_0", icon: AK2_5_84343_0 },
  { key: "AK2_6_121228_0", icon: AK2_6_121228_0 },
  { key: "AK2_6_127443_0", icon: AK2_6_127443_0 },
  { key: "AK2_6_744343_0", icon: AK2_6_744343_0 },
  { key: "AK2_7_1212127_0", icon: AK2_7_1212127_0 },
  { key: "AK2_7_1212128_0", icon: AK2_7_1212128_0 },
  { key: "AK2_7_1212743_0", icon: AK2_7_1212743_0 },
  { key: "AK2_7_1212843_0", icon: AK2_7_1212843_0 },
  { key: "AK2_7_1274343_0", icon: AK2_7_1274343_0 },
  { key: "AK2_7_1284343_0", icon: AK2_7_1284343_0 },
  { key: "AK2_7_7434343_0", icon: AK2_7_7434343_0 },
  { key: "AK2_7_8434343_0", icon: AK2_7_8434343_0 },
];
